import React, { useEffect, useState } from 'react';
import { useDriverInactivityAlert } from '../hooks/useDriverInactivityAlert';

const buildFormState = (settings) => ({
    isEnabled: Boolean(settings?.isEnabled),
    sendTime: settings?.sendTime || '09:00',
    inactivityDays: settings?.inactivityDays ? String(settings.inactivityDays) : '3',
    title: settings?.title || '',
    body: settings?.body || '',
});

export const DriverInactivityAlertPanel = () => {
    const { settings, isLoading, updateDriverInactivityAlertSettings } = useDriverInactivityAlert();
    const [formData, setFormData] = useState(() => buildFormState(settings));
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (settings) {
            setFormData(buildFormState(settings));
        }
    }, [settings]);

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.sendTime) return setError('وقت الإرسال مطلوب');
        if (!formData.inactivityDays || Number(formData.inactivityDays) < 1) {
            return setError('عدد الأيام يجب أن يكون رقمًا أكبر من صفر');
        }
        if (!formData.title.trim()) return setError('عنوان الإشعار مطلوب');
        if (!formData.body.trim()) return setError('محتوى الإشعار مطلوب');

        setIsSaving(true);
        setError('');
        try {
            await updateDriverInactivityAlertSettings({
                isEnabled: formData.isEnabled,
                sendTime: formData.sendTime,
                inactivityDays: Number(formData.inactivityDays),
                title: formData.title.trim(),
                body: formData.body.trim(),
            });
        } catch (err) {
            setError(err.message || 'حدث خطأ أثناء حفظ الإعدادات');
        } finally {
            setIsSaving(false);
        }
    };

    if (isLoading) {
        return <div className="loading">جاري التحميل...</div>;
    }

    return (
        <div className="driver-inactivity-alert-panel">
            <p className="panel-description">
                إرسال تنبيه يومي تلقائي للسائقين النشطين الذين لم يفتحوا التطبيق (لم يتم تحديث موقعهم) لعدد الأيام المحدد أدناه.
            </p>

            <form onSubmit={handleSubmit}>
                <div className="input-group checkbox-group">
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={formData.isEnabled}
                            onChange={(e) => handleChange('isEnabled', e.target.checked)}
                        />
                        <span>تفعيل التنبيه التلقائي</span>
                    </label>
                </div>

                <div className="form-row">
                    <div className="input-group">
                        <label>وقت الإرسال</label>
                        <input
                            type="time"
                            value={formData.sendTime}
                            onChange={(e) => handleChange('sendTime', e.target.value)}
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label>الحد الأدنى لعدد أيام عدم فتح التطبيق</label>
                        <input
                            type="number"
                            min="1"
                            value={formData.inactivityDays}
                            onChange={(e) => handleChange('inactivityDays', e.target.value)}
                        />
                        <p className="field-hint">مثال: 3 يعني إرسال التنبيه لكل سائق نشط لم يحدّث موقعه منذ 3 أيام أو أكثر</p>
                    </div>
                </div>

                <div className="input-group">
                    <label>عنوان الإشعار</label>
                    <input
                        type="text"
                        value={formData.title}
                        onChange={(e) => handleChange('title', e.target.value)}
                        placeholder="أدخل عنوان الإشعار"
                        required
                    />
                </div>

                <div className="input-group">
                    <label>محتوى الإشعار</label>
                    <textarea
                        value={formData.body}
                        onChange={(e) => handleChange('body', e.target.value)}
                        placeholder="أدخل محتوى الإشعار"
                        rows="4"
                        required
                    />
                </div>

                {error && <div className="error-message">{error}</div>}

                <div className="panel-actions">
                    <button type="submit" className="submit-btn" disabled={isSaving}>
                        {isSaving ? (
                            <>
                                <span className="loading-spinner"></span>
                                جاري الحفظ...
                            </>
                        ) : 'حفظ الإعدادات'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default DriverInactivityAlertPanel;
